import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import { CheckIcon } from '@heroicons/react/outline'
import ClientService from '../../../services/ClientService';

const ClientsForm = ({ userData, modalTitle, setIsOpen, addClient }) => {
    let history = useHistory();

    const {
        needsAPlan: needsAPlanData,
        name: nameData,
        personalCardNumber: personalCardNumberData,
        email: emailData,
        gender: genderData,
        allergiesString: allergiesStringData,
        birthday: birthdayData,
        bloodPressureIssues: bloodPressureIssuesData,
        bloodResults: bloodResultsData,
        breakfastDescription: breakfastDescriptionData,
        breastFeeding: breastFeedingData,
        canBringFoodToSchool: canBringFoodToSchoolData,
        canBringFoodToWork: canBringFoodToWorkData,
        coffee: coffeeData,
        constipationIssues: constipationIssuesData,
        date: dateData,
        dayDescription: dayDescriptionData,
        dinnerDescription: dinnerDescriptionData,
        weekendDescription: weekendDescriptionData,
        dislikesFood: dislikesFoodData,
        foodIntolerance: foodIntoleranceData,
        goal: goalData,
        hasAllergies: hasAllergiesData,
        hasBreaks: hasBreaksData,
        healthIssues: healthIssuesData,
        height: heightData,
        isCookingString: isCookingStringData,
        isEmployed: isEmployedData,
        isPhysicallyActive: isPhysicallyActiveData,
        isPregnant: isPregnantData,
        isSmoker: isSmokerData,
        isStudent: isStudentData,
        isWorkingNightShifts: isWorkingNightShiftsData,
        job: jobData,
        likesFood: likesFoodData,
        lunchDescription: lunchDescriptionData,
        medicines: medicinesData,
        note: noteData,
        corrections: correctionsData,
        numberOfMeals: numberOfMealsData,
        phoneNumber: phoneNumberData,
        physicalActivity: physicalActivityData,
        physicalActivityAmount: physicalActivityAmountData,
        physicalActivityDays: physicalActivityDaysData,
        physicalActivityIntensity: physicalActivityIntensityData,
        physicalActivityTime: physicalActivityTimeData,
        pregnancyMonth: pregnancyMonthData,
        pregnancyWeightGain: pregnancyWeightGainData,
        pregnancyWeightStart: pregnancyWeightStartData,
        schoolSchedule: schoolScheduleData,
        size: sizeData,
        snackDescription: snackDescriptionData,
        softDrinks: softDrinksData,
        alcoholDrinks: alcoholDrinksData,
        tea: teaData,
        waterAmount: waterAmountData,
        weight: weightData,
        workSchedule: workScheduleData,
        worksOnWeekends: worksOnWeekendsData,
    } = userData;

    const [name, setName] = useState(nameData || '');
    const [needsAPlan, setNeedsAPlan] = useState(needsAPlanData || '');
    const [email, setEmail] = useState(emailData || '');
    const [birthday, setBirthday] = useState(birthdayData || '');
    const [personalCardNumber, setPersonalCardNumber] = useState(personalCardNumberData || '');
    const [allergiesString, setAllergiesString] = useState(allergiesStringData || '');
    const [bloodResults, setBloodResults] = useState(bloodResultsData || '');
    const [bloodPressureIssues, setBloodPressureIssues] = useState(bloodPressureIssuesData || '');
    const [breakfastDescription, setBreakfastDescription] = useState(breakfastDescriptionData || '');
    const [breastFeeding, setBreastFeeding] = useState(breastFeedingData || '');
    const [canBringFoodToSchool, setCanBringFoodToSchool] = useState(canBringFoodToSchoolData || false);
    const [canBringFoodToWork, setCanBringFoodToWork] = useState(canBringFoodToWorkData || '');
    const [coffee, setCoffee] = useState(coffeeData || '');
    const [constipationIssues, setConstipationIssues] = useState(constipationIssuesData || '')
    const [date, setDate] = useState(dateData || '');
    const [dayDescription, setDayDescription] = useState(dayDescriptionData || '');
    const [dinnerDescription, setDinnerDescription] = useState(dinnerDescriptionData || '');
    const [weekendDescription, setWeekendDescription] = useState(weekendDescriptionData || '');
    const [dislikesFood, setDislikesFood] = useState(dislikesFoodData || '');
    const [foodIntolerance, setFoodIntolerance] = useState(foodIntoleranceData || '');
    const [gender, setGender] = useState(genderData || '');
    const [goal, setGoal] = useState(goalData || '');
    const [hasAllergies, setHasAllergies] = useState(hasAllergiesData || false);
    const [hasBreaks, setHasBreaks] = useState(hasBreaksData || '');
    const [healthIssues, setHealthIssues] = useState(healthIssuesData || '');
    const [height, setHeight] = useState(heightData || '');
    const [isCookingString, setIsCookingString] = useState(isCookingStringData || '');
    const [isEmployed, setIsEmployed] = useState(isEmployedData || '');
    const [isPhysicallyActive, setIsPhysicallyActive] = useState(isPhysicallyActiveData || '');
    const [isPregnant, setIsPregnant] = useState(isPregnantData || '');
    const [isSmoker, setIsSmoker] = useState(isSmokerData || false);
    const [isStudent, setIsStudent] = useState(isStudentData || false);
    const [isWorkingNightShifts, setIsWorkingNightShifts] = useState(isWorkingNightShiftsData || false);
    const [job, setJob] = useState(jobData || '');
    const [likesFood, setLikesFood] = useState(likesFoodData || '');
    const [lunchDescription, setLunchDescription] = useState(lunchDescriptionData || '');
    const [medicines, setMedicines] = useState(medicinesData || '');
    const [note, setNote] = useState(noteData || '');
    const [corrections, setCorrections] = useState(correctionsData || '');
    const [numberOfMeals, setNumberOfMeals] = useState(numberOfMealsData || '');
    const [phoneNumber, setPhoneNumber] = useState(phoneNumberData || '');
    const [physicalActivity, setPhysicalActivity] = useState(physicalActivityData || '');
    const [physicalActivityAmount, setPhysicalActivityAmount] = useState(physicalActivityAmountData || '');
    const [physicalActivityDays, setPhysicalActivityDays] = useState(physicalActivityDaysData || '');
    const [physicalActivityIntensity, setPhysicalActivityIntensity] = useState(physicalActivityIntensityData || '');
    const [physicalActivityTime, setPhysicalActivityTime] = useState(physicalActivityTimeData || '');
    const [pregnancyMonth, setPregnancyMonth] = useState(pregnancyMonthData || '');
    const [pregnancyWeightGain, setPregnancyWeightGain] = useState(pregnancyWeightGainData || '');
    const [pregnancyWeightStart, setPregnancyWeightStart] = useState(pregnancyWeightStartData || '');
    const [schoolSchedule, setSchoolSchedule] = useState(schoolScheduleData || '');
    const [size, setSize] = useState(sizeData || '');
    const [snackDescription, setSnackDescription] = useState(snackDescriptionData || '');
    const [softDrinks, setSoftDrinks] = useState(softDrinksData || '');
    const [alcoholDrinks, setAlcoholDrinks] = useState(alcoholDrinksData || '');
    const [tea, setTea] = useState(teaData || '');
    const [waterAmount, setWaterAmount] = useState(waterAmountData || '');
    const [weight, setWeight] = useState(weightData || '');
    const [workSchedule, setWorkSchedule] = useState(workScheduleData || '');
    const [worksOnWeekends, setWorksOnWeekends] = useState(worksOnWeekendsData || '');
    const [hasError, setHasError] = useState(false);


    const formValues = {
        needsAPlan,
        personalCardNumber,
        date,
        name,
        gender,
        birthday,
        email,
        phoneNumber,
        height,
        weight,
        size,
        goal,
        healthIssues,
        hasAllergies,
        allergiesString,
        foodIntolerance,
        constipationIssues,
        bloodPressureIssues,
        bloodResults,
        medicines,
        breakfastDescription,
        dayDescription,
        lunchDescription,
        dinnerDescription,
        snackDescription,
        weekendDescription,
        isCookingString,
        dislikesFood,
        likesFood,
        numberOfMeals,
        waterAmount,
        isSmoker,
        coffee,
        tea,
        softDrinks,
        alcoholDrinks,
        isEmployed,
        job,
        workSchedule,
        isWorkingNightShifts,
        worksOnWeekends,
        hasBreaks,
        canBringFoodToWork,
        isStudent,
        schoolSchedule,
        canBringFoodToSchool,
        isPhysicallyActive,
        physicalActivity,
        physicalActivityIntensity,
        physicalActivityAmount,
        physicalActivityDays,
        physicalActivityTime,
        isPregnant,
        pregnancyMonth,
        pregnancyWeightStart,
        pregnancyWeightGain,
        breastFeeding,
        note,
        corrections
    };

    const inputsData = [
        {
            label: 'Potreban je novi plan',
            stateData: needsAPlan,
            setStateData: setNeedsAPlan,
            type: 'checkbox'
        },
        {
            label: 'Broj lične kartice',
            stateData: personalCardNumber,
            setStateData: setPersonalCardNumber,
        },
        {
            label: 'Datum',
            stateData: date,
            setStateData: setDate,
        },
        {
            label: 'Ime i prezime',
            stateData: name,
            setStateData: setName,
        },
        {
            label: 'Pol',
            stateData: gender,
            setStateData: setGender,
        },
        {
            label: 'Datum rođenja',
            stateData: birthday,
            setStateData: setBirthday,
        },
        {
            label: 'Email',
            stateData: email,
            setStateData: setEmail,
        },
        {
            label: 'Broj telefona',
            stateData: phoneNumber,
            setStateData: setPhoneNumber,
        },
        {
            label: 'Visina',
            stateData: height,
            setStateData: setHeight,
        },
        {
            label: 'Težina',
            stateData: weight,
            setStateData: setWeight,
        },
        {
            label: 'Veličina',
            stateData: size,
            setStateData: setSize,
        },
        {
            label: 'Cilj',
            stateData: goal,
            setStateData: setGoal,
        },
        {
            label: 'Problemi sa zdravljem',
            stateData: healthIssues,
            setStateData: setHealthIssues,
        },
        {
            label: 'Da li ima alergije',
            stateData: hasAllergies,
            setStateData: setHasAllergies,
        },
        {
            label: 'Alergije',
            stateData: allergiesString,
            setStateData: setAllergiesString
        },
        {
            label: 'Intolerancija na hranu',
            stateData: foodIntolerance,
            setStateData: setFoodIntolerance,
        },
        {
            label: 'Problemi sa opstipacijom',
            stateData: constipationIssues,
            setStateData: setConstipationIssues,
        },
        {
            label: 'Rezultati krvne analize',
            stateData: bloodResults,
            setStateData: setBloodResults,
            type: 'textarea'
        },
        {
            label: 'Problemi sa krvnim pritiskom',
            stateData: bloodPressureIssues,
            setStateData: setBloodPressureIssues,
        },
        {
            label: 'Lekovi',
            stateData: medicines,
            setStateData: setMedicines,
        },
        {
            label: 'Opis dana',
            stateData: dayDescription,
            setStateData: setDayDescription,
            type: 'textarea'
        },
        {
            label: 'Opis doručka',
            stateData: breakfastDescription,
            setStateData: setBreakfastDescription,
            type: 'textarea'
        },
        {
            label: 'Opis ručka',
            stateData: lunchDescription,
            setStateData: setLunchDescription,
            type: 'textarea'
        },
        {
            label: 'Opis večere',
            stateData: dinnerDescription,
            setStateData: setDinnerDescription,
            type: 'textarea'
        },
        {
            label: 'Opis užine',
            stateData: snackDescription,
            setStateData: setSnackDescription,
            type: 'textarea'
        },
        {
            label: 'Opis vikenda',
            stateData: weekendDescription,
            setStateData: setWeekendDescription,
            type: 'textarea'
        },
        {
            label: 'Da li kuva',
            stateData: isCookingString,
            setStateData: setIsCookingString,
        },
        {
            label: 'Hrana koju ne voli',
            stateData: dislikesFood,
            setStateData: setDislikesFood,
        },
        {
            label: 'Hrana koju voli',
            stateData: likesFood,
            setStateData: setLikesFood,
        },
        {
            label: 'Broj obroka',
            stateData: numberOfMeals,
            setStateData: setNumberOfMeals,
        },
        {
            label: 'Količina vode koju unosi',
            stateData: waterAmount,
            setStateData: setWaterAmount,
        },
        {
            label: 'Pušač',
            stateData: isSmoker,
            setStateData: setIsSmoker,
        },
        {
            label: 'Kafa',
            stateData: coffee,
            setStateData: setCoffee,
        },
        {
            label: 'Čaj',
            stateData: tea,
            setStateData: setTea,
        },
        {
            label: 'Bezalkoholna pića',
            stateData: softDrinks,
            setStateData: setSoftDrinks,
        },
        {
            label: 'Alkoholna pića',
            stateData: alcoholDrinks,
            setStateData: setAlcoholDrinks,
        },
        {
            label: 'Zaposlen/a',
            stateData: isEmployed,
            setStateData: setIsEmployed,
        },
        {
            label: 'Zaposlenje',
            stateData: job,
            setStateData: setJob,
        },
        {
            label: 'Raspored rada',
            stateData: workSchedule,
            setStateData: setWorkSchedule,
        },
        {
            label: 'Radi u noćnim smenama',
            stateData: isWorkingNightShifts,
            setStateData: setIsWorkingNightShifts,
        },
        {
            label: 'Radi vikendom',
            stateData: worksOnWeekends,
            setStateData: setWorksOnWeekends,
        },
        {
            label: 'Ima pauze',
            stateData: hasBreaks,
            setStateData: setHasBreaks,
        },
        {
            label: 'Može da donese hranu na posao',
            stateData: canBringFoodToWork,
            setStateData: setCanBringFoodToWork,
        },
        {
            label: 'Student',
            stateData: isStudent,
            setStateData: setIsStudent,
        },
        {
            label: 'Školski raspored',
            stateData: schoolSchedule,
            setStateData: setSchoolSchedule,
        },
        {
            label: 'Može da donese hranu u školu',
            stateData: canBringFoodToSchool,
            setStateData: setCanBringFoodToSchool,
        },
        {
            label: 'Fizički je aktivan/na',
            stateData: isPhysicallyActive,
            setStateData: setIsPhysicallyActive,
        },
        {
            label: 'Fizička aktivnost',
            stateData: physicalActivity,
            setStateData: setPhysicalActivity,
        },
        {
            label: 'Intenzitet fizičke aktivnosti',
            stateData: physicalActivityIntensity,
            setStateData: setPhysicalActivityIntensity,
        },
        {
            label: 'Količina fizičke aktivnosti',
            stateData: physicalActivityAmount,
            setStateData: setPhysicalActivityAmount,
        },
        {
            label: 'Dani fizičke aktivnosti',
            stateData: physicalActivityDays,
            setStateData: setPhysicalActivityDays,
        },
        {
            label: 'Vreme fizičke aktivnosti',
            stateData: physicalActivityTime,
            setStateData: setPhysicalActivityTime,
        },
        {
            label: 'Trudna',
            stateData: isPregnant,
            setStateData: setIsPregnant,
        },
        {
            label: 'Mesec trudnoće',
            stateData: pregnancyMonth,
            setStateData: setPregnancyMonth,
        },
        {
            label: 'Težina na početku trudnoće',
            stateData: pregnancyWeightStart,
            setStateData: setPregnancyWeightStart,
        },
        {
            label: 'Telesna težina dobijena u toku trudnoće',
            stateData: pregnancyWeightGain,
            setStateData: setPregnancyWeightGain,
        },
        {
            label: 'Doji',
            stateData: breastFeeding,
            setStateData: setBreastFeeding,
        },
        {
            label: 'Beleška',
            stateData: note,
            setStateData: setNote,
            type: 'textarea'
        },
        {
            label: 'Ispravke',
            stateData: corrections,
            setStateData: setCorrections,
            type: 'textarea'
        },

    ]


    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }

    const viewMeasurements = () => {
        window.open("/#/home/measurements/" + userData.id)
    }

    const viewPlans = () => {
        window.open("/#/home/plan-history/" + userData.id)
    }



    const emailRegex = /^[a-zA-Z0-9.!#$%&"*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    const handleFormSubmit = e => {
        e.preventDefault();
        setIsOpen(false);
        addClient(userData, formValues)

    }
    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>{modalTitle}</h3>
            <form className="flex flex-wrap w-full mt-6 px-4">

                <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                <button className="button bg-secondaryGradient mx-auto my-2" onClick={e => viewMeasurements(e)}>
                    Pogledaj Mere
                </button>
                <button className="button bg-secondaryGradient mx-auto my-2" onClick={e => viewPlans(e)}>
                    Pogledaj Planove
                </button>
                {inputsData.map(({ stateData, setStateData, label, type }, i) => (
                    <div className="w-full md:w-6/12 2xl:w-4/12 px-2 mt-3" key={i}>
                        {
                            type === 'textarea' &&
                            <div className="input-group">
                                <label htmlFor={i} className="font-medium text-xs text-gray-500">{label}</label>
                                <textarea type="text" id={i} value={stateData} onChange={(e) => setStateData(e.target.value)} className="input-field" ></textarea>
                            </div>
                        }
                        {
                            type === 'checkbox' &&
                            <div className="input-group checkbox">
                                <input type="checkbox" id={i} defaultChecked={stateData} onChange={(e) => setStateData(!stateData)} className="input-field" />
                                <label htmlFor={i} className="font-medium text-xs text-gray-500"><span className='check'><CheckIcon /></span>{label}</label>
                            </div>
                        }
                        {
                            type !== 'checkbox' && type !== 'textarea' &&
                            <div className="input-group">
                                <label htmlFor={i} className="font-medium text-xs text-gray-500">{label}</label>
                                <input type="text" id={i} value={stateData} onChange={(e) => setStateData(e.target.value)} className="input-field" />
                            </div>
                        }

                    </div>
                )
                )}
                <button type="submit" className="button without-icon bg-secondaryGradient mx-auto my-2" onClick={e => handleFormSubmit(e)}>
                    Sačuvaj
                </button>
            </form>
        </>
    )
}

export default ClientsForm;
